import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';

// Timer Countdown component for notifying refresh
function Timer({ refreshFrequency }) {
    const [seconds, setSeconds] = useState(refreshFrequency);
    const intervalRef = useRef();

    useEffect(() => {
        intervalRef.current = setInterval(() => {
            setSeconds((t) => t - 1);
        }, 1000);
        return () => clearInterval(intervalRef.current);
    }, []);

    useEffect(() => {
        if (seconds <= 0) {
            clearInterval(intervalRef.current);
        }
    }, [seconds]);

    return <div className="refresh-body">Next refresh in: {seconds} seconds</div>
}

Timer.propTypes = {
    refreshFrequency: PropTypes.number.isRequired
};

export default Timer;
